import styled from "styled-components";

export const ContainerDropdownDescription = styled.div``;

export const BodyContainerDropdownDescription = styled.div<{isActive?: boolean}>`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 4px 16px;
  gap: 8px;
  height: 28px;
  background: #f1f5f9;
  box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
  border-radius: 8px;
  cursor: pointer;
  border: ${(props) => (props.isActive ? "1px solid #70B7F5" : "")};
  color: ${(props) => (props.isActive ? "#70B7F5" : "")};
`;

export const DropdownDescription = styled.div`
  background: #f8fafc;
  border-radius: 0px 0px 16px 16px;
  padding: 10px;
`;
